module.exports = __webpack_public_path__ + "static/cursor-active-invert-ed40cac97ceffb86d97f9310758baf17.svg";